<template>
  <div class="phone-input">
    <div class="input-group">
      <input type="tel"
             :placeholder="placeholder"
             class="form-control"
             ref="input"
             @input.native="onInput"
             @focus.native="onInput"
             @click="show"
             v-model="phone">
    </div>
    <div id="numpad-wrap" ref="numpad" v-show="numberPadShow">
      <div id="numpad-btns">
        <div class="numpad-btn" @click="clickNum(7)">7</div>
        <div class="numpad-btn" @click="clickNum(8)">8</div>
        <div class="numpad-btn" @click="clickNum(9)">9</div>
        <div class="numpad-btn" @click="clickNum(4)">4</div>
        <div class="numpad-btn" @click="clickNum(5)">5</div>
        <div class="numpad-btn" @click="clickNum(6)">6</div>
        <div class="numpad-btn" @click="clickNum(1)">1</div>
        <div class="numpad-btn" @click="clickNum(2)">2</div>
        <div class="numpad-btn" @click="clickNum(3)">3</div>
        <div class="numpad-btn zero" @click="clickNum(0)">0</div>
        <div class="numpad-btn ng" @click="deleteNum" ref="deleteButton">⤆</div>
        <div class="numpad-btn ok" @click="complete">✔</div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'PhoneInput',
    props: {
      value: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '0000-0000-0000'
      },
      onlyNumber: {
        type: Boolean,
        default: true
      },
      maxlength: {
        type: Number
      }
    },
    data () {
      return {
        value_old: '',
        pos: 0,
        numberPadEvent: '',
        numberPadShow: false,
      };
    },
    mounted: function () {
      this.numberPadShow = false;
      this.$nextTick(() => {
        this.$emit('input', this.$options.filters.decodeInternationalPhoneNumber(this.value));
      });
      // 範囲外クリック
      window.addEventListener('click', e => {
        if (!this.$el.contains(e.target)){
          this.hide();
        }
      });
    },
    computed: {
      phone: {
        get () {
          return this.$options.filters.decodeInternationalPhoneNumber(this.value);
        },
        set (value) {
          this.$emit('input', this.$options.filters.decodeInternationalPhoneNumber(value));
        }
      }
    },
    methods: {
      // @todo テンキー入力でボタンをアクティブにする
      simulateActive(el) {
        const evt = document.createEvent("UIEvents");
        evt.initUIEvent("DOMActivate", true, false, window,1);

        const cancelled = !el.dispatchEvent(evt);

        if(cancelled) {
          // console.log("cancelled");

        } else {
          // console.log("not cancelled");
        }
      },
      onInput(event) {
        if (event.target.value === '') return;
        if (event.target.value === this.value_old) return;
        this.value_old = event.target.value;
        this.phone = event.target.value;
        if (event.inputType === 'deleteContentBackward') {  // バックスペース
          this.simulateActive(this.$refs.deleteButton.$el);
          this.numberPadEvent = 'deleteContentBackward';
        } else if (event.inputType === 'insertCompositionText') { // 全角入力
          return;
        } else if (event.inputType === 'insertText' ) { // 半角入力
          this.numberPadEvent = 'insertText';
        }
        this.formatted_call_to_number();
      },
      formatted_call_to_number () {
        if (this.maxlength) {
          this.phone = this.phone.slice(0, this.maxlength);
        }
        if (this.numberPadEvent === 'deleteContentBackward') {
          if (this.value_old[this.value_old.length - 1] === '-') {
            this.$emit('input', this.phone.slice(0, this.phone.length - 1));
          }
        } else if (this.numberPadEvent === 'insertText') {
          this.phone = this.removeNotNumber(this.phone);
          this.phone = this.$options.filters.decodeInternationalPhoneNumber(this.phone);
          if (this.phone !== this.value_old) {
            this.pos -= (this.value_old.length - this.phone.length);
          }
          this.$emit('input', this.phone);
        } else {
          // this.$emit('input', this.removeNotNumber(this.phone));
        }
        // if (event.inputType === undefined) {
        //   this.$nextTick(() => {
        //     this.$refs.input.selectionStart = this.pos;
        //     this.$refs.input.selectionEnd = this.pos;
        //     this.$refs.input.focus();
        //   });
        // }
      },
      removeNotNumber (value) {
        if (!this.onlyNumber) return value;
        if (!value) return value;
        value = value.replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        value = value.replace(/[^0-9-]/g, '');
        this.$refs.input.value = value;
        return value;
      },
      show : function () {
        // this.numberPadShow = true;
        // this.$refs.numpad.classList.remove("hide");
        this.$refs.input.focus();
        this.pos = this.$refs.input.selectionStart;
      },
      complete: function () {
        this.$emit('complete');
        this.hide();
      },
      hide : function () {
        this.numberPadShow = false;
        // this.$refs.numpad.classList.add("hide");
      },
      deleteNum : function () {
        this.numberPadEvent = 'deleteContentBackward';
        this.pos = this.$refs.input.selectionStart;
        let value = '';
        if (this.phone[this.pos - 1] === '-') {
          this.pos -= 2;
          value = this.phone.slice(0, this.pos) + this.phone.slice(this.pos + 2);

        } else {
          this.pos -= 1;
          value = this.phone.slice(0, this.pos) + this.phone.slice(this.pos + 1);
        }
        this.value_old = value;
        // this.formatted_call_to_number();
        this.$emit('input', value);
        this.$nextTick(() => {
          this.$refs.input.selectionStart = this.pos;
          this.$refs.input.selectionEnd = this.pos;
          this.$refs.input.focus();
        });
      },
      clickNum(number) {
        this.numberPadEvent = 'insertText';
        this.pos = this.$refs.input.selectionStart;
        const value = this.$refs.input.value.substr(0, this.pos) +
          number + this.$refs.input.value.substr(this.pos);
        this.value_old = value;
        this.$emit('input', value);
        this.pos++;
        this.$nextTick(() => {
          this.$refs.input.focus();
        });
      },
    }
  };
</script>

<style lang="scss" scoped>
  .input-group {
    .input-group-addon {
      padding: 6px 10px;
      font-size: 14px;
      font-weight: normal;
      line-height: 1;
      color: #555;
      background-color: #e0e3e0;
      text-align: center;
      border: 1px solid #ccc;
      &:first-child {
        border-right: 0;
      }
    }
    .form-control {
      font-size: inherit;
    }
  }
  /* [NUMPAD] */
  #numpad-wrap {
    /* FONT - REMOVE THIS TO FOLLOW YOUR CURRENT THEME */
    font-family: 'Arial', sans-serif;
  }
  #numpad-wrap {
    position: absolute;
    max-width: 240px;
    margin: 0;
    padding: 10px;
    background: #f2f2f2;
    border: 1px solid #ccc;
    z-index: 10001;
  }

  /* [NUMBER BUTTONS] */
  #numpad-btns {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .numpad-btn {
    box-sizing: border-box;
    width: 33.3%;
    padding: 10px;
    border: 1px solid #aaa;
    background: #444;
    color: #fff;
    text-align: center;
    font-size: 1.5em;
    &:active {
      cursor: -webkit-grabbing;
      cursor: -moz-grabbing;
      animation: spinner 200ms infinite linear;
    }
  }
  .numpad-btn.zero {
    /*width: 66.6%;*/
  }
  .numpad-btn.ninja {
    display: none;
  }
  .numpad-btn.ng {
    background: #333;
  }
  .numpad-btn.cx {
    background: #B23025;
    border: 1px solid #C73D32;
  }
  .numpad-btn.ok {
    background: #1FA83A;
    border: 1px solid #1FC72D;
  }
  /*
  .numpad-btn:hover {
    cursor: pointer;
  }
  @keyframes spinner {
    from {
      box-shadow: 0 10px 20px rgba( 0,0,0, 0.2 );
      transform: rotateY( 0 ) rotateX( -360deg );	}

    to {
      box-shadow: 0 10px 20px rgba( 0,0,0, 0.2 );
      transform: rotateY( 360deg ) rotateX( -360deg ); }
  }
  */
</style>

